import React from 'react';
import { ResponsiveLine  } from '@nivo/line' 

export default function LineGraph({data}) {

  /*const data = [
    {
      "id": "Avaliações",
      "data": [
        {
          "x": "plane",
          "y": 266
        },
        {
          "x": "helicopter",
          "y": 118
        },
        {
          "x": "boat",
          "y": 218
        }
      ]
    },
    {
      "id": "Vendas",
      "data": [
        {
          "x": "plane",
          "y": 102
        },
        {
          "x": "helicopter",
          "y": 25
        },
        {
          "x": "boat",
          "y": 162
        }
      ]
    }
  ];*/

return(
    <ResponsiveLine
        data={data}
        margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
        axisTop={null}
        axisRight={null}
        colors= {['rgb(57, 115, 156)','rgba(57, 115, 156, 0.30)']}
        axisBottom={{
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: ' ',
            legendOffset: 36,
            legendPosition: 'middle'
        }}
        axisLeft={{
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Quantidade',
            legendOffset: -40,
            legendPosition: 'middle'
        }}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabel="y"
        pointLabelYOffset={-12}
        useMesh={true}
        legends={[
            {
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 100,
                translateY: 0,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
    />
)};